import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight, X } from 'lucide-react';
interface PhotoCarouselProps {
  photos: string[];
}
export function PhotoCarousel({
  photos
}: PhotoCarouselProps) {
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const handlePrevious = () => {
    setCurrentIndex(prev => prev === 0 ? photos.length - 1 : prev - 1);
  };
  const handleNext = () => {
    setCurrentIndex(prev => prev === photos.length - 1 ? 0 : prev + 1);
  };
  return <>
      {/* Horizontal Scrollable Thumbnails */}
      <div className="flex gap-2 overflow-x-auto pb-2 snap-x snap-mandatory scrollbar-hide -mx-4 px-4" data-id="element-166">
        {photos.map((photo, index) => <motion.button key={index} onClick={() => {
        setSelectedIndex(index);
        setCurrentIndex(index);
      }} whileTap={{
        scale: 0.95
      }} className="flex-shrink-0 w-20 h-20 rounded-lg overflow-hidden border-2 border-gray-200 hover:border-teal-deep transition-colors snap-start touch-manipulation" data-id="element-167">
            <img src={photo} alt={`Foto ${index + 1}`} className="w-full h-full object-cover" data-id="element-168" />
          </motion.button>)}
      </div>

      {/* Fullscreen Modal */}
      <AnimatePresence data-id="element-169">
        {selectedIndex !== null && <>
            {/* Backdrop */}
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={() => setSelectedIndex(null)} className="fixed inset-0 bg-black/90 z-50" data-id="element-170" />

            {/* Fullscreen Image */}
            <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-171">
              <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} exit={{
            opacity: 0,
            scale: 0.9
          }} className="relative w-full h-full max-w-4xl max-h-[90vh]" data-id="element-172">
                <img src={photos[currentIndex]} alt={`Foto ${currentIndex + 1}`} className="w-full h-full object-contain" data-id="element-173" />

                {/* Close Button */}
                <button onClick={() => setSelectedIndex(null)} className="absolute top-4 right-4 w-12 h-12 bg-white/10 backdrop-blur-sm hover:bg-white/20 rounded-full flex items-center justify-center transition-colors touch-manipulation" data-id="element-174">
                  <X className="w-6 h-6 text-white" data-id="element-175" />
                </button>

                {/* Navigation Arrows */}
                {photos.length > 1 && <>
                    <button onClick={handlePrevious} className="absolute left-4 top-1/2 -translate-y-1/2 w-12 h-12 bg-white/10 backdrop-blur-sm hover:bg-white/20 rounded-full flex items-center justify-center transition-colors touch-manipulation" data-id="element-176">
                      <ChevronLeft className="w-6 h-6 text-white" data-id="element-177" />
                    </button>
                    <button onClick={handleNext} className="absolute right-4 top-1/2 -translate-y-1/2 w-12 h-12 bg-white/10 backdrop-blur-sm hover:bg-white/20 rounded-full flex items-center justify-center transition-colors touch-manipulation" data-id="element-178">
                      <ChevronRight className="w-6 h-6 text-white" data-id="element-179" />
                    </button>
                  </>}

                {/* Counter */}
                <div className="absolute bottom-4 left-1/2 -translate-x-1/2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full" data-id="element-180">
                  <span className="text-white text-sm font-medium" data-id="element-181">
                    {currentIndex + 1} / {photos.length}
                  </span>
                </div>
              </motion.div>
            </div>
          </>}
      </AnimatePresence>
    </>;
}